export const processField = (field, form_data, raw_data, store_data) => {
    const dbKey = field.config.dbKey;
    const type = field.config.type;
    const fieldName = field.config.fieldName;
    let value = field.value;

    if (value === undefined) {
        value = null;
    }

    if (dbKey && dbKey in form_data) {
        form_data[dbKey] = typeof form_data[dbKey] === "number" ? Number(value) : value;
    } else {
        if (dbKey && dbKey !== "fileUpload" && field.config.type === "file") {
            raw_data.push({
                value: value ?? "",
                label: field.label,
                fieldName: dbKey,
                valueType: "file"
            });
        } else if (type && type === "yes-no") {
            raw_data.push({
                value: value === "Yes" ? true : false,
                label: field.label,
                fieldName: fieldName,
                valueType: "boolean"
            });
        } else if (dbKey && dbKey === "fileUpload" && field.config.type === "file") {
            raw_data.push({
                value: value ?? "",
                label: field.label,
                fieldName: fieldName,
                valueType: "file"
            });
        } else {
            raw_data.push({
                value: value ?? "",
                label: field.label,
                fieldName: fieldName,
                valueType: field.config.varType
            });
        }
    }

    store_data[fieldName] = value;
};


export const processShareholdersSection = (section, ubos) => {
    const uboMap = {};

    section.fields.forEach(field => {
        const uboId = field.config.uboId;
        const fieldName = field.config.dbKey;
        let value = field.value || "";

        if (!uboMap[uboId]) {
            uboMap[uboId] = {};
        }

        if (fieldName === "authorized_signatory") {
            value = value === "Yes" ? true : value === "No" ? false : value;
        }

        if (value !== "" || !uboMap[uboId][fieldName]) {
            uboMap[uboId][fieldName] = value;
        }
    });

    Object.values(uboMap).forEach(ubo => {
        ubos.push(ubo);
    });
};

export const processFormData = (data) => {
    const form_data = {
        "firstname": null,
        "lastname": null,
        "email": null,
        "address": null,
        "address_line_2": null,
        "address_country": null,
        "county": null,
        "postcode": null,
        "id_number": null,
        "id_type": null,
        "city_state": null,
        "birth_day": null,
        "Nationality": null,
        "Birthplace": null,
        "Country": null
    };

    const raw_data = [];
    const store_data = {}

    data.forEach(item => {
        if (item.config.type === "section") {
            item.fields.forEach(field => {
                if (field.visible !== false) {
                    processField(field, form_data, raw_data, store_data);
                }
            });
        } else {
            processField(item, form_data, raw_data, store_data);
        }
    });

    return { raw_data, store_data, form_data };
}

export const processCompanyFormData = (data) => {
    const form_data = {
        "company_name": null,
        "company_email": null,
        "registration_number": null,
        "date_of_incorporation": null,
        "registered_address": null,
        "business_type": null,
        "industry_type": null,
        "business_status": null,
        "merchant_company_id": null,
        "url": null,
        "registered_country": null,
        "registered_city_state": null,
        "registered_postcode": null,
        "registered_county": null,
        "north_data_id": null,
        "revenue": -1,
        "revenue_currency": null,
        "account_number": null,
        "policy_number": null,
        "coverage_amount": -1,
        "coverage_amount_currency": null,
        "insurance_expiry_date": null,
        "Country": null
    };

    const raw_data = [];
    const store_data = {};
    const ubos = [];

    data.forEach(item => {
        if (item.config.component === "Key Individuals and Entities") {
            processShareholdersSection(item, ubos);
            return;
        }
        if (item.config.type !== "section") {
            processField(item, form_data, raw_data, store_data);
            return;
        }

        item.fields.forEach(field => {
            if (field.visible !== false) {
                processField(field, form_data, raw_data, store_data);
            }
        });
    });

    return { raw_data, store_data, form_data, ubos };
}

export const processEddFormData = (data) => {
    const form_data = {
    };

    const raw_data = [];
    const store_data = {};
    const ubos = [];

    data.forEach(item => {
        if (item.config.type !== "section") {
            processField(item, form_data, raw_data, store_data);
            return;
        }

        if (item.config.component === "Key Individuals and Entities") {
            processShareholdersSection(item, ubos);
            return;
        }

        item.fields.forEach(field => {
            if (field.visible !== false) {
                processField(field, form_data, raw_data, store_data);
            }
        });
    });

    return { raw_data, store_data, form_data, ubos };
}

export const filterValidUbos = (ubos) => {
    const cleanedUbos = ubos
        .map((ubo, index) => {
            const cleaned = Object.entries(ubo).reduce((acc, [key, value]) => {
                const isValid =
                    value !== null &&
                    value !== undefined &&
                    value !== 0 &&
                    !(typeof value === "string" && value.trim() === "");

                if (isValid) {
                    acc[key] = value;
                }
                return acc;
            }, {});

            if (Object.keys(cleaned).length === 0) {
                return null;
            }

            return cleaned;
        })
        .filter(ubo => ubo !== null);

    return cleanedUbos;
};

export const filterRawData = (rawData) =>
    rawData.filter(item =>
        item.value !== -1 &&
        item.value !== null &&
        item.value !== undefined &&
        item.value !== "" &&
        !(Array.isArray(item.value) && item.value.length === 0) &&
        !(typeof item.value === "object" &&
            !(item.value instanceof Date) &&
            item.value !== null &&
            Object.keys(item.value).length === 0)
    );

export const filterFormData = (formData) =>
    Object.fromEntries(
        Object.entries(formData).filter(([_, value]) =>
            value !== -1 &&
            value !== null &&
            value !== undefined &&
            value !== "" &&
            !(Array.isArray(value) && value.length === 0) &&
            !(typeof value === "object" &&
                !(value instanceof Date) &&
                value !== null &&
                Object.keys(value).length === 0)
        )
    );

export const prepareEddResponse = (formData) => {
    const hasValidUbos = Array.isArray(formData.ubos) && formData.ubos.length > 0;

    const uboFields = hasValidUbos
        ? formData.ubos.map((ubo, index) => ({
            value: ubo,
            fieldName: `ubo${index + 1}`,
            label: `UBO ${index + 1}`,
            valueType: "object"
        }))
        : [];

    return [...formData.raw_data, ...uboFields];
};